export default "/build/images/Snapchat-300x291.png?b95318c2a6413bd7768e7fef97b6a3f0";